/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchCollection
 */
export interface SearchCollection {
    /**
     * 
     * @type {string}
     * @memberof SearchCollection
     */
    hostname: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCollection
     */
    name: string;
}

/**
 * Check if a given object implements the SearchCollection interface.
 */
export function instanceOfSearchCollection(value: object): value is SearchCollection {
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SearchCollectionFromJSON(json: any): SearchCollection {
    return SearchCollectionFromJSONTyped(json, false);
}

export function SearchCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCollection {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'],
        'name': json['name'],
    };
}

export function SearchCollectionToJSON(value?: SearchCollection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'hostname': value['hostname'],
        'name': value['name'],
    };
}

